import { all, call, put, select, takeLatest } from "redux-saga/effects";
import config from "../../config";
import { actionCreators, actionTypes } from "./actions";
import { http } from "../../common/lib";
import { logToSentry } from "../../config/Sentry";

function* post(actions) {
    const { form } = actions.payload;
    try {
        const { organisation } = yield select((state) => state);

        if (!organisation.supportEmail)
            yield put(actionCreators.postFailure(error.toString()));
        else {
            const mailData = {
                recipient: organisation.supportEmail,
                template: "support_email",
                context: {
                    contact_name: form.contactName,
                    contact_email: form.emailAddress,
                    organisation: organisation.name,
                    subject: form.subject,
                    filetype_description: form.description,
                    status_date: new Date().toISOString(),
                    priority: form.priority,
                    classification: form.classification,
                },
            };

            //TODO if form will be used outside of auth session, http.public may need to be switched
            yield call(
                http.authorized.post,
                config.api.paths.sendMail,
                mailData
            );

            yield put(actionCreators.postSuccess());
        }
    } catch (error) {
        const errStr = error.toString();
        logToSentry("app support post", {
            error,
            errStr,
            actionPayload: actions.payload,
        });
        yield put(actionCreators.postFailure(errStr));
    }
}

// For testing
export { post };
export default (function* () {
    yield all([takeLatest(actionTypes.APP_SUPPORT_POST_REQUEST, post)]);
})();
